'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = function className(type) {
  var classObject = {};
  classObject['quiver-alert'] = true;
  classObject['quiver-alert--' + type] = !!type;
  return (0, _classnames2.default)(classObject);
};

var Alert = function Alert(_ref) {
  var children = _ref.children,
      type = _ref.type,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { className: className(type), style: style },
    children
  );
};

Alert.propTypes = {
  type: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
};

exports.default = Alert;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Alert/Alert.js
// module id = 518
// module chunks = 11